import React, { Component } from 'react';

class InclusionExclusion extends Component {
    render() {
        return (
            <>
                <h4 className='tomato'><u>INCLUSIONS : <strong>LAKSHWADEEP PACKAGE TOUR FROM KOCHI</strong></u></h4><br/>
                <ul>
                <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Entry Permit to Lakshadweep Islands
                    </li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Airport pick up and drop
                    </li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;A/C accommodation on double sharing</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Breakfast, Lunch & Dinner</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;All sightseeing</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Vessel tickets both ways</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Jetty pick up and drop by A/C vehicle</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;24/7 Local Coordinator Support</li><br/>
                </ul>
                <br/><br/><br/>
                <h4 className='tomato'><u>EXCLUSIONS : <strong>LAKSHWADEEP TOUR PACKAGE FROM KOCHI WITH FLIGHT</strong></u></h4><br/>
                <ul>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Air Fare / Cruise Fare</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Water sports activities like Scuba Diving and Kayaking</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Any item which is not mentioned in the 'Inclusion' section</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Laundry, Tips, phone call or any such personal expenses</li><br/>
                </ul>
            </>
        );
    }
}

export default InclusionExclusion;